import { gql, useQuery } from "@apollo/client";
import React, { useState, useCallback } from "react";
import DailyChart from "./DailyChart";
import LineRangePicker from "./LineRangePicker";
import { error } from "../../../../Controllers/toast";
import { SyncOutlined } from "@ant-design/icons";
import { Col, Row } from "reactstrap";
import { Button } from "antd";
import { useSelector } from "react-redux";
import { toGregorianAPIString, toJalaliString } from "../../../../Utils/dateUtils";

const GET_GATEWAY_PRODUCTIONS = gql`
  query Optimizer($Gateway_id: Int!, $date_time: [Date!],$time_offset: Int!) {
    CreateGroupDataProduction(Gateway_id: $Gateway_id, date_time: $date_time,time_offset:$time_offset) {
      Iline
      Vline
      date_time
    }
  }
`;

const ChartComponentLine = ({ setDateHOC, dateHOC, Gateway_id }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const lang_choiced = useSelector((state) => state.lang_change);

  // تبدیل تاریخ‌ها برای API
  const getFormattedDates = useCallback(() => {
    if (!dateHOC || !Array.isArray(dateHOC) || dateHOC.length !== 2) {
      const today = toGregorianAPIString(new Date());
      return [today, today];
    }
    
    return [
      toGregorianAPIString(dateHOC[0]),
      toGregorianAPIString(dateHOC[1])
    ];
  }, [dateHOC]);

  const { refetch } = useQuery(GET_GATEWAY_PRODUCTIONS, {
    variables: {
      Gateway_id,
      date_time: getFormattedDates(),
      time_offset: new Date().getTimezoneOffset(),
    },
    onCompleted: (res) => {
      const data_created = createChartData(res.CreateGroupDataProduction);
      setData(res.CreateGroupDataProduction ? data_created : []);
      setLoading(false);
    },
    onError: (err) => {
      console.error(err);
      setData([]);
      setLoading(false);
      error("مشکلی در دریافت اطلاعات رخ داده است!");
    },
    fetchPolicy: "network-only",
  });

  const createChartData = (data) => {
    if (!data || !Array.isArray(data)) return [];
    
    return data.map((product) => {
      let newDate = new Date(parseInt(product.date_time));
      return {
        Vline: product.Vline,
        Iline: product.Iline,
        Pline: product.Vline * product.Iline,
        date: newDate,
      };
    });
  };

  const handleDateChange = (newDates) => {
    // newDates رشته شمسی است
    setDateHOC(newDates);
    setLoading(true);
    
    refetch({
      date_time: [
        toGregorianAPIString(newDates[0]),
        toGregorianAPIString(newDates[1])
      ],
      Gateway_id,
      time_offset: new Date().getTimezoneOffset(),
    }).then((res) => {
      setData(createChartData(res.data.CreateGroupDataProduction));
      setLoading(false);
    });
  };

  const handleRefresh = () => {
    setData([]);
    setLoading(true);
    
    refetch({
      date_time: getFormattedDates(),
      Gateway_id,
      time_offset: new Date().getTimezoneOffset(),
    }).then((res) => {
      setData(createChartData(res.data?.CreateGroupDataProduction || []));
      setLoading(false);
    });
  };

  return (
    <div>
      <Row className="text-center">
        <Col>
          <LineRangePicker
            dateHOC={dateHOC}
            setDatesHOC={handleDateChange}
            isPanel
          />
        </Col>
      </Row>
      <Button
        onClick={handleRefresh}
        icon={<SyncOutlined size={256} />}
        type="link"
      >
        {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.chartTab.btnUpdate}
      </Button>
      <DailyChart data={data} dateHOC={dateHOC} loading={loading} />
    </div>
  );
};

export default ChartComponentLine;